/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A tool referenced by a tool filter scope, identified by URN and display name.
 */
export type ToolFilterTool = {
  /**
   * The display name of the tool, with any variation rename from the resolved group applied (matching the runtime wire)
   */
  name: string;
  /**
   * The URN of the tool
   */
  toolUrn: string;
};

/** @internal */
export const ToolFilterTool$inboundSchema: z.ZodMiniType<
  ToolFilterTool,
  unknown
> = z.pipe(
  z.object({
    name: z.string(),
    tool_urn: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tool_urn": "toolUrn",
    });
  }),
);

export function toolFilterToolFromJSON(
  jsonString: string,
): SafeParseResult<ToolFilterTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolFilterTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolFilterTool' from JSON`,
  );
}
